import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "ventania",
        nomePrefeitura: "Prefeitura Municipal de Ventania",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/ventania/logos/logo.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/ventania/logos/brasao.png",
        municipio: "| Ventania - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: "",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-50.24525963061764, -24.246759407736374],
            zoom: 18,
        },
    },
    api: {
        url: "https://api-prd.semv.com.br/ventania/",
    },
    geoserver: {
        url: "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
